<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><span>Also in Arrow by Evelyn Anthony</span></p>
<p class="fm1"><span><i>Albatross</i></span></p>
<p class="fm1"><span><i>The Assassin</i></span></p>
<p class="fm1"><span><i>The Avenue of the Dead</i></span></p>
<p class="fm1"><span><i>The Company of Saints</i></span></p>
<p class="fm1"><span><i>The Defector</i></span></p>
<p class="fm1"><span><i>The Legend</i></span></p>
<p class="fm1"><span><i>The Malaspiga Exit</i></span></p>
<p class="fm1"><span><i>The Occupying Power</i></span></p>
<p class="fm1"><span><i>The Poellenberg Inheritance</i></span></p>
<p class="fm1"><span><i>The Rendezvous</i></span></p>
<p class="fm1"><span><i>The Return</i></span></p>
<p class="fm1"><span><i>No Enemy But Time</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?8dc23e62